import { renderErrorMessages } from 'common-components/view-logic'
import _ from 'lodash'

const BasicPlanErrorMessages = ({ premiumValue }) => {
  let messageType = _.isEmpty(premiumValue.errors) ? null : premiumValue.errors[0].type
  return <div>{renderErrorMessages('premium-error-message')(premiumValue.errors, messageType)}</div>
}

export default BasicPlanErrorMessages
